import SentimentsItem from './SentimentsItem';

interface SentimentsProp {
  callSentiment: any;
}
const Sentiments = ({ callSentiment }: SentimentsProp) => {
  const { confidencePositive, confidenceNeutral, confidenceNegative } =
    callSentiment;

  return (
    <div className="sentiment-body-item">
      <SentimentsItem sentiment={'Positive'} value={confidencePositive} />
      <SentimentsItem sentiment={'Neutral'} value={confidenceNeutral} />
      <SentimentsItem sentiment={'Negative'} value={confidenceNegative} />
    </div>
  );
};

export default Sentiments;
